// extracted by mini-css-extract-plugin
export default {"bodyInfo":"BodyInfo_bodyInfo__doG5N","title":"BodyInfo_title__2MUhs"};